// @flow
import type { Node } from 'react';

import React from 'react';
import { EnhancedField } from '#components/support/forms/utility/index.js';
import ReadOnlyView from '#components/pages/Components/support/form/ComponentFormField/ReadOnlyView/index.jsx';

// TODO: considering updating the EnhancedField to cover the additional functionality added here
type Props = {
  excludeInputGroup?: boolean,
  excludeLabel?: boolean,
  excludeTip?: boolean,
  excludeFeedback?: boolean,
  field: Object,
  item?: string | null,
  render?: Function,
  visible: boolean,
  readOnly?: boolean,
};

const ComponentFormField = ({
  excludeInputGroup = false,
  excludeLabel = false,
  excludeTip = false,
  excludeFeedback = false,
  field,
  item = null,
  render = null,
  visible,
  readOnly = false,
}: Props): Node => (
  <EnhancedField
    excludeInputGroup={excludeInputGroup}
    excludeLabel={excludeLabel}
    excludeTip={excludeTip}
    excludeFeedback={excludeFeedback}
    field={field}
    item={item}
    render={render}
    visible={visible}
    readOnly={readOnly}
    readOnlyComponent={ReadOnlyView}
  />
);

export default ComponentFormField;
